import {
  Button,
  PhoneMockup,
  PhoneMockupBodyLayout,
  PhoneMockupLayout,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetStatus,
} from '@frontend/ui-library';
import { getIdFromUrl } from '@frontend/utils';
import { useEffect } from 'react';

import {
  SatisfactionRating,
  TopBar,
  TransactionDropdown,
  addStatusToTransactions,
} from '../../components';
import { useWidgetContext } from '../../context/WidgetContext';

import {
  PageFields_OverpaidPage_Fragment,
  PageFields_PaidPage_Fragment as PaymentSucceedFields,
} from '../../graphql/generated';
import { useRegisterHotjarPage } from '../../hooks';
import { isOfframpBill } from '../../utils';

interface PaymentSucceedProps {
  data:
    | PaymentSucceedFields['paidPageData']
    | PageFields_OverpaidPage_Fragment['pageData'];
}

const PaymentSucceed = ({ data }: PaymentSucceedProps) => {
  const { configureHeader } = useWidgetContext();

  useEffect(() => {
    configureHeader({
      id: getIdFromUrl(),
      merchantName: data?.merchantName || '',
      billType: data?.billType,
    });
  }, []);

  useRegisterHotjarPage('payment-succeed');

  const isOffRamp = isOfframpBill(data?.billType || '');

  return (
    <PhoneMockupLayout>
      <PhoneMockup
        header={
          <WidgetHeader color="success">
            <WidgetHeaderContent title="Success" />
          </WidgetHeader>
        }
      >
        <PhoneMockupBodyLayout
          header={
            <TopBar
              rightSlot={
                data?.confirmedTransactions && (
                  <TransactionDropdown
                    transactions={addStatusToTransactions(
                      data.confirmedTransactions,
                      'confirmed'
                    )}
                  />
                )
              }
            />
          }
          bodyCentered
          body={
            <>
              <WidgetStatus
                emoji="🎉"
                title={`${isOffRamp ? 'Off ramp' : 'Payment'} complete`}
                description={
                  isOffRamp ? (
                    'The traded amount will be credited to your bank account.'
                  ) : (
                    <>
                      You just paid for something with crypto!
                      <br />
                      Welcome to the future.
                    </>
                  )
                }
              />
              <SatisfactionRating mt="32" rating={data?.rating || undefined} />
            </>
          }
          footer={
            data?.returnUrl && (
              <Button
                as="a"
                href={data.returnUrl}
                mt="16"
                size="large"
                variant="secondary"
              >
                Go back to store
              </Button>
            )
          }
        />
      </PhoneMockup>
    </PhoneMockupLayout>
  );
};

export default PaymentSucceed;
